var $5d5e2106fbc5feb1$exports = {};
$5d5e2106fbc5feb1$exports = {
    "collapse": `\u{421}\u{432}\u{438}\u{432}\u{430}\u{43D}\u{435}`,
    "expand": `\u{420}\u{430}\u{437}\u{448}\u{438}\u{440}\u{44F}\u{432}\u{430}\u{43D}\u{435}`
};


export {$5d5e2106fbc5feb1$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
